import {IntlKeyValuePair, IntlNamespaces} from "./types";

export const INTL_SETTINGS: IntlKeyValuePair = {
    key: "settings",
    defaultValue: "Settings",
    intlValue: "Settings",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_MY_SETTINGS: IntlKeyValuePair = {
    key: "mySettings",
    defaultValue: "My Settings",
    intlValue: "My Settings",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_PERSONAL_INFORMATION: IntlKeyValuePair = {
    key: "personalInformation",
    defaultValue: "Personal information",
    intlValue: "Personal information",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_ADD: IntlKeyValuePair = {
    key: "add",
    defaultValue: "Add",
    intlValue: "Add",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_EDIT: IntlKeyValuePair = {
    key: "edit",
    defaultValue: "Edit",
    intlValue: "Edit",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_SAVE: IntlKeyValuePair = {
    key: "save",
    defaultValue: "Save",
    intlValue: "Save",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_FIRST_NAME: IntlKeyValuePair = {
    key: "firstName",
    defaultValue: "First name",
    intlValue: "First name",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_ADD_YOUR_FIRST_NAME: IntlKeyValuePair = {
    key: "addYourFirstName",
    defaultValue: "Add your first name",
    intlValue: "Add your first name",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_LAST_NAME: IntlKeyValuePair = {
    key: "lastName",
    defaultValue: "Last name",
    intlValue: "Last name",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_ADD_YOUR_LAST_NAME: IntlKeyValuePair = {
    key: "addYourLastName",
    defaultValue: "Add your last name",
    intlValue: "Add your last name",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_EMAIL: IntlKeyValuePair = {
    key: "email",
    defaultValue: "Email notifications for new messages",
    intlValue: "Email notifications for new messages",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_ADD_YOUR_EMAIL: IntlKeyValuePair = {
    key: "addYourEmail",
    defaultValue: "Add your email",
    intlValue: "Add your email",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_MOBILE: IntlKeyValuePair = {
    key: "mobile",
    defaultValue: "Mobile",
    intlValue: "Mobile",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_EXAMPLE_PHONE_NUMBER: IntlKeyValuePair = {
    key: "examplePhoneNumber",
    defaultValue: "e.g. +447700900775",
    intlValue: "e.g. +447700900775",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_EXAMPLE: IntlKeyValuePair = {
    key: "example",
    defaultValue: "e.g.",
    intlValue: "e.g.",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_I_COME_FROM: IntlKeyValuePair = {
    key: "iComeFrom",
    defaultValue: "I come from",
    intlValue: "I come from",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_REGION: IntlKeyValuePair = {
    key: "region",
    defaultValue: "Domestic Region",
    intlValue: "Domestic Region",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_DEGREE_LEVEL: IntlKeyValuePair = {
    key: "degreeLevel",
    defaultValue: "What degree level are you interested in?",
    intlValue: "What degree level are you interested in?",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_SELECT_A_DEGREE: IntlKeyValuePair = {
    key: "selectADegree",
    defaultValue: "Select a level",
    intlValue: "Select a level",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_AREA_OF_STUDY: IntlKeyValuePair = {
    key: "areaOfStudy",
    defaultValue: "Area of Study",
    intlValue: "Area of Study",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_SELECT_ARES_OF_STUDY: IntlKeyValuePair = {
    key: "selectAresOfStudy",
    defaultValue: "Select one or more areas of study you are interested in",
    intlValue: "Select one or more areas of study you are interested in",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_EMPTY_AREA_OF_STUDY_LIST: IntlKeyValuePair = {
    key: "emptyAreaOfStudyList",
    defaultValue: "No courses are currently listed under area of study level you’ve chosen",
    intlValue: "No courses are currently listed under area of study level you’ve chosen",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_SELECT: IntlKeyValuePair = {
    key: "select",
    defaultValue: "Select",
    intlValue: "Select",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_SELECT_DATE: IntlKeyValuePair = {
    key: "selectDate",
    defaultValue: "Select Date",
    intlValue: "Select Date",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_NOTIFICATION_PREFERENCES: IntlKeyValuePair = {
    key: "notificationPreferences",
    defaultValue: "Unibuddy notification preferences",
    intlValue: "Unibuddy notification preferences",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_NEW_MESSAGES: IntlKeyValuePair = {
    key: "newMessages",
    defaultValue: "New message notifications",
    intlValue: "New message notifications",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_SMS: IntlKeyValuePair = {
    key: "sms",
    defaultValue: "SMS notifications for new messages",
    intlValue: "SMS notifications for new messages",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_WHATSAPP: IntlKeyValuePair = {
    key: "whatsapp",
    defaultValue: "WhatsApp notifications for new messages",
    intlValue: "WhatsApp notifications for new messages",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_ADD_MOBILE_NUMBER: IntlKeyValuePair = {
    key: "addMobileNumber",
    defaultValue: "mobile number required",
    intlValue: "mobile number required",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_MARKETING_MESSAGES: IntlKeyValuePair = {
    key: "marketingMessages",
    defaultValue: "Institutional marketing messages within Unibuddy",
    intlValue: "Institutional marketing messages within Unibuddy",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_YES: IntlKeyValuePair = {
    key: "yes",
    defaultValue: "Yes",
    intlValue: "Yes",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_NO: IntlKeyValuePair = {
    key: "no",
    defaultValue: "No",
    intlValue: "No",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_AGREEMENT_TO_DIRECT_MARKETING: IntlKeyValuePair = {
    key: "agreementToDirectMarketing",
    defaultValue:
        "If you agreed to direct marketing from the Institution when you created your account, you will need to change your communication preferences directly with them.",
    intlValue:
        "If you agreed to direct marketing from the Institution when you created your account, you will need to change your communication preferences directly with them.",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_UNIBUDDY_PRIVACY_POLICY: IntlKeyValuePair = {
    key: "unibuddyPrivacyPolicy",
    defaultValue: "Unibuddy Privacy Policy",
    intlValue: "Unibuddy Privacy Policy",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_INSTITUTION_PRIVACY_POLICY: IntlKeyValuePair = {
    key: "institutionPrivacyPolicy",
    defaultValue: "Institution Privacy Policy",
    intlValue: "Institution Privacy Policy",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_TERMS_OF_USE: IntlKeyValuePair = {
    key: "termsOfUse",
    defaultValue: "Terms of Use",
    intlValue: "Terms of Use",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_ACCEPTABLE_USE_POLICY: IntlKeyValuePair = {
    key: "acceptableUsePolicy",
    defaultValue: "Acceptable Use Policy",
    intlValue: "Acceptable Use Policy",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_COOKIE_POLICY: IntlKeyValuePair = {
    key: "cookiePolicy",
    defaultValue: "Cookie Policy",
    intlValue: "Cookie Policy",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_LIST_OF_SUB_PROCESSORS: IntlKeyValuePair = {
    key: "listOfSubProcessors",
    defaultValue: "List of Sub-Processors",
    intlValue: "List of Sub-Processors",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_CONTACT_UNIBUDDY: IntlKeyValuePair = {
    key: "contactUnibuddy",
    defaultValue: "Contact Unibuddy for technical support questions",
    intlValue: "Contact Unibuddy for technical support questions",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_DELETE_ACCOUNT: IntlKeyValuePair = {
    key: "deleteAccount",
    defaultValue: "Delete Account",
    intlValue: "Delete Account",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_LOGOUT: IntlKeyValuePair = {
    key: "logout",
    defaultValue: "Log out",
    intlValue: "Log out",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_DELETE_MY_ACCOUNT: IntlKeyValuePair = {
    key: "deleteMyAccount",
    defaultValue: "Delete My Account",
    intlValue: "Delete My Account",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_CANCEL: IntlKeyValuePair = {
    key: "cancel",
    defaultValue: "Cancel",
    intlValue: "Cancel",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_ACCOUNT_DELETION_CONFIRMATION: IntlKeyValuePair = {
    key: "accountDeletionConfirmation",
    defaultValue: "Are you sure you want to delete your account?",
    intlValue: "Are you sure you want to delete your account?",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_ACCOUNT_DELETION_FINAL: IntlKeyValuePair = {
    key: "accountDeletionFinal",
    defaultValue: "Account deletion is final. There will be no way to restore your account.",
    intlValue: "Account deletion is final. There will be no way to restore your account.",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_TODAY: IntlKeyValuePair = {
    key: "today",
    defaultValue: "Today",
    intlValue: "Today",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_LANGUAGE_PREFERENCE: IntlKeyValuePair = {
    key: "languagePreference",
    defaultValue: "Preferred language for notifications?",
    intlValue: "Preferred language for notifications?",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_SELECT_LANGUAGE: IntlKeyValuePair = {
    key: "selectLanguage",
    defaultValue: "Select Language",
    intlValue: "Select Language",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_EDIT_FIRST_NAME: IntlKeyValuePair = {
    key: "editFirstName",
    defaultValue: "Edit first name",
    intlValue: "Edit first name",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_EDIT_LAST_NAME: IntlKeyValuePair = {
    key: "editLastName",
    defaultValue: "Edit last name",
    intlValue: "Edit last name",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_EDIT_EMAIL: IntlKeyValuePair = {
    key: "editEmail",
    defaultValue: "Edit email",
    intlValue: "Edit email",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_EDIT_MOBILE: IntlKeyValuePair = {
    key: "editMobile",
    defaultValue: "Edit mobile",
    intlValue: "Edit mobile",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_SAVE_FIRST_NAME: IntlKeyValuePair = {
    key: "saveFirstName",
    defaultValue: "Save first name",
    intlValue: "Save first name",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_SAVE_LAST_NAME: IntlKeyValuePair = {
    key: "saveLastName",
    defaultValue: "Save last name",
    intlValue: "Save last name",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_SAVE_EMAIL: IntlKeyValuePair = {
    key: "saveEmail",
    defaultValue: "Save email",
    intlValue: "Save email",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_SAVE_MOBILE: IntlKeyValuePair = {
    key: "saveMobile",
    defaultValue: "Save mobile",
    intlValue: "Save mobile",
    namespace: IntlNamespaces.SETTINGS,
};

export const INTL_ACCOUNT_STATEMENTS_POLICIES: IntlKeyValuePair = {
    key: "accountStatementsPolicies",
    defaultValue: "Account, statements and policies",
    intlValue: "Account, statements and policies",
    namespace: IntlNamespaces.SETTINGS,
};
